import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { DataGrid } from '@mui/x-data-grid';
import { Button } from '@mui/material';
import NumberedDataGridPagination from 'components/NumberedDataGridPagination';
import { actions } from './UserManagement.redux';

const UsersTable = () => {
    const dispatch = useDispatch();
    const users = useSelector((state) => state.users.users);
    const columns = [
        { field: 'login_name', headerName: 'Name', flex: 1, minWidth: 180, sortable: false },
        { field: 'login_email', headerName: 'Email', flex: 1, minWidth: 220, sortable: false },
        {
            field: 'is_admin',
            headerName: 'User Type',
            flex: 1,
            minWidth: 160,
            sortable: false,
            renderCell: (params) => (params.value ? 'Admin' : 'Standard User'),
        },
        {
            field: 'remove',
            headerName: 'Remove from Clinic',
            flex: 1,
            minWidth: 180,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => {
                if (params.row.is_current_user === false) {
                    return (
                        <Button
                            color="secondary"
                            variant="contained"
                            onClick={(event) => {
                                event.stopPropagation();
                                dispatch(
                                    actions.setState({
                                        showDeleteModal: true,
                                        deleteInfo: { ...params.row },
                                    })
                                );
                            }}
                        >
                            Remove
                        </Button>
                    );
                }

                return <></>;
            },
        },
    ];

    return (
        <div>
            <DataGrid
                rows={users}
                columns={columns}
                getRowId={(row) => row.login_id}
                pageSizeOptions={[5, 10, 20, 50]}
                initialState={{
                    pagination: {
                        paginationModel: { page: 0, pageSize: 10 },
                    },
                }}
                disableRowSelectionOnClick
                disableColumnMenu
                disableCellFocus
                sx={{
                    '& .MuiDataGrid-row': { cursor: 'pointer' },
                    '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': { outline: 'none' },
                    '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': { outline: 'none' },
                }}
                slots={{ pagination: NumberedDataGridPagination }}
                autoHeight
            />
        </div>
    );
};

export default UsersTable;
